import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

if (document.getElementsByClassName('case-studies-section__slider')[0]) {
  const caseStudiesSlidersArr = document.querySelectorAll('.case-studies-section__slider');
  caseStudiesSlidersArr.forEach((sliderEl, sliderIdx) => {
    const pagination = sliderEl.querySelector('.swiper-pagination');
    /*const slides = sliderEl.querySelectorAll('.swiper-slide');
    let loop = false;
    let loopedSlides = false;

    if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/

    let pauseOnMouseEnter = window.innerWidth > 1024;

    const caseStudiesSwiper = new Swiper(sliderEl, {
      modules: [Autoplay, Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      threshold: 10,
      /*loop: loop,
      loopedSlides: loopedSlides,*/
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnMouseEnter,
      },
      /*pagination: {
        el: pagination,
        clickable: true,
      },*/
      navigation: {
        prevEl: sliderEl.querySelector('.slider-buttons .slider-btn.prev'),
        nextEl: sliderEl.querySelector('.slider-buttons .slider-btn.next'),
      },
      breakpoints: {
        451: {
          spaceBetween: 20,
          slidesPerView: 1.3,
        },
        651: {
          spaceBetween: 16,
          slidesPerView: 1.5,
        },
        901: {
          spaceBetween: 20,
          slidesPerView: 1.5,
        },
        1024: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 30,
          slidesPerView: 2,
        },
      },
    });

    swiperObserver(caseStudiesSwiper);
  });
}
